import React from "react";
import { useNavigate } from "react-router-dom";

type PropsType = {
  hospitalName?: String;
  vetName?: String;
  email?: String;
  _id?: String;
};

const CareTeamTableMobile = ({
  hospitalName,
  vetName,
  email,
  _id,
}: PropsType) => {
  const navigate = useNavigate();
  return (
    <div className="tw-w-[80%] tw-mx-auto tw-bg-white tw-py-6 tw-shadow-small tw-rounded-[1rem]">
      <div className="tw-w-[90%] tw-mx-auto tw-flex tw-flex-col tw-gap-3">
        {/* 1st main col */}
        <div className="tw-flex tw-flex-col tw-gap-2">
          {/* 1st col */}
          <div className="tw-flex tw-items-center tw-justify-between tw-gap-4">
            <span className="tw-font-bold tw-text-base tw-text-darkPurple ">
              Hospital Name
            </span>
            <span className="">
              {" "}
              {hospitalName !== "" ? hospitalName : "None"}
            </span>
          </div>

          {/* 2nd col */}
          <div className="tw-flex tw-items-center tw-justify-between tw-gap-4">
            <span className="tw-font-bold tw-text-base tw-text-darkPurple ">
              Veterinarian Name
            </span>
            <span className="tw-text-center">
              {" "}
              {vetName !== "" ? vetName : "None"}
            </span>
          </div>

          {/* 3rd col */}
          <div className="tw-flex tw-items-center tw-justify-between tw-gap-4">
            <span className="tw-font-bold tw-text-base tw-text-darkPurple">
              Email
            </span>
            <span className="tw-truncate ">
              {email !== "" ? email : "None"}
            </span>
          </div>
        </div>
        {/* 2nd main col */}
        <div className="tw-w-[80%] tw-mx-auto tw-flex tw-items-center tw-justify-center">
          <button
            className="tw-bg-darkRed tw-py-1.5 tw-px-8 tw-rounded-[0.625rem] tw-text-[0.75rem] tw-text-[#FFFFFF]"
            onClick={() => {
              navigate(`/user/care-team/contact-info/${_id}`);
            }}
          >
            Contact Details
          </button>
        </div>
      </div>
    </div>
  );
};

export default CareTeamTableMobile;
